// extracted by mini-css-extract-plugin
module.exports = {"loaderContainer":"Loader_loaderContainer__qkvdD","spinner":"Loader_spinner___f6A7","spin":"Loader_spin__4_xhr"};